import { Stack, Theme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  children: ReactNode;
  onClose?: () => void;
}

const useStyles = createUseStyles((theme: Theme) => ({
  appSidebarTab: {
    position: 'relative',
    color: theme.palette.text.primary,
  },
  closeButton: {
    position: 'absolute',
    top: 6,
    right: 16,
    '& svg': {
      color: theme.palette.text.primary,
    },
  },
}));

const Tab: FC<Props> = ({ children }) => {
  const styles = useStyles();

  return (
    <Stack gap={1} width="100%" height="100%" className={styles.appSidebarTab}>
      {children}
    </Stack>
  );
};

export default Tab;
